var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInput),expression:"searchInput"}],staticClass:"form-control",attrs:{"placeholder":_vm.placeholder,"type":"text"},domProps:{"value":(_vm.searchInput)},on:{"input":function($event){if($event.target.composing)return;_vm.searchInput=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }